import { useEffect } from "react";
import Header from "../../ui-components/Header";
import Footer from "../../ui-components/Footer";
import { Typography, Box } from "@mui/material";
import AOS from "aos";
import "../Users/Welcome/style.scss";
import "./Agreement.scss";
import "aos/dist/aos.css";
import moment from "moment";

const RefundPolicies = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
  });
  return (
    <div className="welcome">
      <Header />

      <div className="container">
        <Box className="agreement">
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            data-aos="fade-up"
          >
            Refund Policies
          </Typography>

          <Typography
            variant="subtitle2"
            component="p"
            data-aos="fade-up"
            fontWeight={600}
          >
            Effective Date: {"  "}
            {moment().format("DD/MM/YYYY")}.
            <br />
            Company: Pellifix
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            At Pellifix, we strive to provide a transparent and trustworthy
            matrimony experience. Please read our Refund Policy carefully before
            purchasing any paid membership or service.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            1. General Policy
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            All payments made on Pellifix for membership plans, profile boosts,
            premium features, or add-on services are generally non-refundable,
            unless otherwise stated in this policy.
            <br />
            By subscribing to any paid service, you agree to the terms outlined
            below.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            2. Eligible Refund Scenarios
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            A refund may be considered only under the following circumstances:
            <br />
            Duplicate Payment: If you are charged more than once for the same
            service.
            <br />
            Technical Error: If a paid service is not activated due to a
            verified technical issue from Pellifix’s side.
            <br />
            Incorrect Billing: If an incorrect amount is deducted due to a
            system error.
            <br />
            In such cases, the refund will be processed after verification by
            our support team.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            3. Non-Refundable Scenarios
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            Refunds will not be issued in the following cases:
            <br />
            Change of mind after purchasing a membership.
            <br />
            Dissatisfaction with matches, responses, or user activity.
            <br />
            Lack of responses from other members.
            <br />
            Partial usage of membership or services.
            <br />
            Account suspension or termination due to violation of Pellifix’s
            Terms & Conditions.
            <br />
            Deletion of profile by the user.
            <br />
            Failure to find a suitable match.
            <br />
            Matrimony outcomes depend on mutual interest and compatibility;
            hence, results cannot be guaranteed.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            4. Subscription Cancellation
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            Users may cancel auto-renewal (if applicable) at any time.
            <br />
            Cancellation will stop future billing but does not qualify for a
            refund of the current subscription period.
            <br />
            Paid services will remain active until the end of the subscription
            term.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            5. Refund Process
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            If your case qualifies for a refund:
            <br />
            Submit a refund request to{" "}
            <a href="mailto:support@pellifix.com">support@pellifix.com </a>.
            <br />
            Include:
            <br />
            Registered email ID
            <br />
            Payment receipt or transaction ID
            <br />
            Reason for refund
            <br />
            Our team will review the request within 7–10 business days.
            <br />
            If approved, the refund will be credited to the original payment
            method within 7–14 business days, depending on the bank or payment
            provider.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            6. Payment Gateway Charges
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            Any payment gateway or bank charges deducted during the transaction
            are non-refundable and may be excluded from the refund amount.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            7. Changes to This Policy
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            Pellifix reserves the right to modify this Refund Policy at any
            time. Updates will be posted on this page, and continued use of our
            services implies acceptance of the revised policy.
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            data-aos="fade-up"
          >
            8. Contact Us
          </Typography>
          <Typography variant="subtitle2" component="p" data-aos="fade-up">
            For any questions or concerns regarding this Refund Policy, please
            contact us:
            <br />
            Email:{" "}
            <a href="mailto: support@pellifix.com">support@pellifix.com </a>
            <br />
            Address: Pellifix, Near kalpana Gas Godowns, 16-13-359/1,
            haranathapuram, Vidhyanagar layout, Nellore, SPSR Nellore, Andhra
            Pradesh, 524001
          </Typography>
        </Box>
      </div>
      <Footer />
    </div>
  );
};
export default RefundPolicies;
